'use client';

import { useCallback, useEffect, useTransition } from 'react';
import { usePathname, useRouter } from 'next/navigation';

// Going to other results from the same page - a filter, a chip, the sort. The
// list dims while the new one is fetched ("search-pending", listened to by
// components/results/ResultsGrid.tsx) and comes back when it has arrived.
//
// push adds a step to the history (the filter panel: Back undoes a whole set
// of choices); replace does not (a chip or a desktop filter, adjusted one
// click at a time).
export function useResultsNavigation() {
  const router = useRouter();
  const pathname = usePathname();
  const [isPending, startTransition] = useTransition();

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('search-pending', { detail: isPending }));
  }, [isPending]);

  return useCallback(
    (params: URLSearchParams, mode: 'push' | 'replace' = 'replace') => {
      const qs = params.toString();
      const url = qs ? `${pathname}?${qs}` : pathname;
      window.dispatchEvent(new CustomEvent('search-pending', { detail: true }));
      startTransition(() => {
        if (mode === 'push') router.push(url, { scroll: false });
        else router.replace(url, { scroll: false });
      });
    },
    [pathname, router]
  );
}
